import { useDispatch} from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import glenArnisdale_small from '../../img/walks/glenArnisdale_small.jpg'; 
import glenArnisdale_medium from '../../img/walks/glenArnisdale_medium.jpg'; 
import glenArnisdale_large from '../../img/walks/glenArnisdale_large.jpg'; 

const WalkLochansDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
    </div>
    <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">Gleann Dubh Lochain</h2>
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-directions">1. Start walking to Corran.
            </p>      
            <p className="walk-directions">2. Take the left turn for Glenfield House private road. Pass through a gate.
            </p>      
            <p className="walk-directions">3. Walk along the river until you cross a bridge.
            </p>      
            <p className="walk-directions">4. Continue for another mile before the track goes steeply uphill.
            </p>      
            <p className="walk-directions">5. With a beautiful view back along the Glen the track stays up high until the lochans. There are two lochans 
                                            and a small waterfall at the outflow of the 1st one.
            </p>      
            <p className="walk-directions">6. Return by the same route.
            </p>      
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">3-4 hours.
            </p>                                           
          </div>
        </div>
      </div>
    <div className="col-12 imagesBackgroundColour walk-image"> 
      <picture>
        <source srcSet={`${glenArnisdale_small} 1x,${glenArnisdale_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${glenArnisdale_medium} 1x,${glenArnisdale_large} 2x`}
          src={glenArnisdale_medium} alt="Glen Arnisdale" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default WalkLochansDetails
